import { SoapUtils } from '../../../../utils/SoapUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export class Itemvalue {
    formItem:     string;
    formItemName: string;
    value:        string;

    constructor(formItem: string, formItemName: string, value: string) {
        this.formItem = formItem;
        this.formItemName = formItemName;
        this.value = value;
    }

    public toXml(): string {
        var parameters: string = '';

        parameters += SoapUtils.makeNode(this.formItem, 'formItem');
        parameters += SoapUtils.makeNode(this.formItemName, 'formItemName');
        parameters += SoapUtils.makeNode(this.value, 'value');

        return `<ITEMVALUE>${parameters}</ITEMVALUE>`;
    }
}

export interface IUpdateFormItemValuesRequest extends IBaseRequest {
    formValuesId?: string;
    context?: string;
    formId?: string;
    remoteId?: string;
    remoteAcl?: string;
    remoteIdType?: string;
    ITEMVALUE?: Itemvalue[];

}

export class UpdateFormItemValuesRequest extends BaseRequest implements IUpdateFormItemValuesRequest {

    public formValuesId?: string;
    public context?: string;
    public formId?: string;
    public remoteId?: string;
    public remoteAcl?: string;
    public remoteIdType?: string;
    public ITEMVALUE?: Itemvalue[];

    constructor(server: string, session: string, formValuesId?: string, context?: string, formId?: string, remoteId?: string, remoteAcl?: string, remoteIdType?: string, ITEMVALUE?: Itemvalue[]) {
        super(server, session);
        this.formValuesId = formValuesId;
        this.context = context;
        this.formId = formId;
        this.remoteId = remoteId;
        this.remoteAcl = remoteAcl;
        this.remoteIdType = remoteIdType;
        this.ITEMVALUE = ITEMVALUE;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.formValuesId, 'formValuesId');
        parameters += this.makeNode(this.context, 'context');
        parameters += this.makeNode(this.formId, 'formId');
        parameters += this.makeNode(this.remoteId, 'remoteId');
        parameters += this.makeNode(this.remoteAcl, 'remoteAcl');
        parameters += this.makeNode(this.remoteIdType, 'remoteIdType');
        if(this.ITEMVALUE) parameters += this.ITEMVALUE.map((item) => item.toXml()).join('');
        
        return super.wrapperXml('UpdateFormItemValues', parameters);
    }
}
